<template>
	<div
		class="c-language-navigation"
		role="navigation"
		aria-label="sekundær navigation"
	>
		<button
			class="
				bg-blue
				text-white
				rounded-full
				h-48
				flex
				justify-center
				items-center
				mr-5
				>=768:mr-12
			"
			aria-label="Vis "
			@click="onShow()"
		>
			<span class="uppercase font-Rubik font-semibold px-12">
				<SvgLanguage class="c-language-navigation__language-icon" />
			</span>
		</button>

		<Portal v-if="isOpen" to="SpaOverlay">
			<div
				class="
					fixed
					top-0
					right-0
					w-full
					h-full
					bg-blue
					text-white
					z-30
				"
			>
				<div
					class="
						relative
						w-full
						max-w-1440
						mx-auto
						py-100
						>=768:py-150
					"
				>
					<button
						class="
							fixed
							>=768:absolute
							top-30
							right-20
							>=768:top-33
							rounded-full
							bg-white
							w-48
							h-48
							flex
							justify-center
							items-center
							text-blue
							transform
							hover:rotate-180
							transition
							duration-500
							ease-in-out
							>=768:right-40
						"
						@click="onClose()"
					>
						<SvgClose class="w-12 h-12" />
					</button>
					<nav
						class="
							c-language-navigation__nav
							h-full
							w-full
							gap-50
							px-20
							>=768:py-13 >=768:px-100
						"
					>
						<NuxtLinkExtVue
							v-for="item in items"
							:key="item.id"
							:to="item.url"
							class="
								text-white
								uppercase
								font-bold
								block
								leading-initial
								mt-24
								text-16
								first:pt-0
								>=768:leading-24 >=768:mt-15 >=768:text-20
								opacity-100
							"
							target="_self"
							:class="{
								'c-languave-navigation__nav-link--active':
									item.url == activeUrl,
							}"
							@click.native="onClose()"
							v-html="item.title"
						></NuxtLinkExtVue>
					</nav>
				</div>
			</div>
		</Portal>
		<CrawlerOnly>
			<nav aria-label="Sprogvalg">
				<ul>
					<li>
						<a href="https://flyttilvestfyn.assens.dk/">DANSK</a>
					</li>
					<li>
						<a href="https://movetowestfunen.assens.dk/">ENGLISH</a>
					</li>
				</ul>
			</nav>
		</CrawlerOnly>
	</div>
</template>

<script>
import NuxtLinkExtVue from '~/citi-baseline/components/NuxtLinkExt.vue';
import SvgClose from '~/assets/svgs/close.svg?inline';
import SvgLanguage from '~/assets/svgs/language.svg?inline';
import CrawlerOnly from '~/components/main/CrawlerOnly';

export default {
	name: 'TranslationNavigation',

	components: {
		NuxtLinkExtVue,
		SvgClose,
		SvgLanguage,
		CrawlerOnly,
	},

	props: {
		sticky: {
			type: Boolean,
			default: false,
		},
	},

	data() {
		const items = [
			{
				url: 'https://flyttilvestfyn.assens.dk/',
				title: 'DANSK',
			},
			{
				url: 'https://movetowestfunen.assens.dk/',
				title: 'ENGLISH',
			},
		];
		return {
			isOpen: false,
			index: 0,
			items,
		};
	},

	computed: {
		activeUrl() {
			if (typeof window !== 'undefined') {
				return window.location;
			} else {
				return true;
			}
		},
	},
	created() {
		this.$on('overlay.close', this.onClose);
	},
	methods: {
		onClose() {
			this.isOpen = false;
		},
		onShow() {
			this.isOpen = true;
		},
	},
};
</script>
<style lang="postcss">
.c-language-navigation__language-icon {
	width: 24px;
	height: 24px;
}

.c-languave-navigation__nav-link--active {
	opacity: 0.3 !important;
}
</style>
